export enum Role {
  MASTERADMIN = 'Master Admin',
  CUSTOMERADMIN = 'Customer Admin',
  UNITADMIN = 'Unit Admin',
  COO = 'COO',
  CMO = 'CMO',
  UNITHEAD = 'Unit Head',
  MINECELLHO = 'Mine Cell - HO',
  FH = 'FH',
  DHMINEOPERATION = 'DH Mine Operation',
  PLANNINGENGINEER = 'Planning Engineer',
  DRILLBLASTENGINEER = 'Drill/Blast Engineer',
  MINEOPERATIONENGINEER = 'Mine Operation Engineer',
  QCANALYSIS = 'QC Analysis',
  DHMINEMAINTENANCE = 'DH Mine Maintenance',
  MAINTENANCEENGINEER = 'DH Mine Maintenance',
  UNKNOWN = 'Unknown',
  FIELDENGINEER = 'Field Engineer',
  SHIFTINCHARGE = 'Shift In-Charge (Mines)'
}